import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import styles from "../styles/Course.module.css";
import styles2 from "../styles/Header.module.css";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import first from "../assets/img/first.png";
import second from "../assets/img/second.png";

function Courses() {
  return (
    <div>
      <Header />
      <div className={styles.container}>
        <h1 style={{ textAlign: "center", color: "#2841a5" }}>
          آکادمی تخصصی بلاک چین
        </h1>
        <div className={styles.inputsContainer}>
          <div className={styles.firstInput}>
            <input className={styles.input} placeholder="جستجو" />
          </div>
          <div className={styles.firstInput}>
            <div className={styles.dropdown}>
              <input className={styles.input} placeholder="مرتب سازی بر اساس" />
              <div className={styles2.dropdownContent}>
                <Link>پیش فرض</Link>
                <Link>محبوبیت</Link>
                <Link>آخرین</Link>
                <Link>ارزانترین</Link>
                <Link>گرانترین</Link>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.cardContainer}>
          <Card
            style={{ border: "none", borderRadius: "2rem", marginTop: "1rem" }}
            className={styles.Card}
          >
            <Card.Img
              style={{ borderRadius: "1rem" }}
              variant="top"
              src={first}
            />
            <Card.Body style={{ padding: "1rem" }}>
              <Link to="/blockchain-specialist">
                <h5>دوره پیشرفته بلاک چین</h5>
              </Link>
              <p style={{ textAlign: "left", marginTop: "1rem" }}>1,000,000</p>
            </Card.Body>
          </Card>
          <Card
            style={{ border: "none", borderRadius: "2rem", marginTop: "1rem" }}
            className={styles.Card}
          >
            <Card.Img
              style={{ borderRadius: "1rem" }}
              variant="top"
              src={second}
            />
            <Card.Body style={{ padding: "1rem" }}>
              <Link to="/blockchain-specialist">
                <h5>دوره تخصصی بلاک چین</h5>
              </Link>
              <p style={{ textAlign: "left", marginTop: "1rem" }}>1,000,000</p>
            </Card.Body>
          </Card>
        </div>
      </div>
      {/* <section className={styles.footer}>
        <Footer />
      </section> */}
    </div>
  );
}

export default Courses;
